/*
Author: Atul Vasudevan
Story: ENT-2317
 */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { RequestService } from "../../../../services/request/request.service";
import { AlertBannerService, AlertType } from "../../../../lib/alert-banner";
import moment from "moment";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import { WarningModalContentComponent } from "../../../../lib/warning-modal/warning-modal.component";
import { PermissionsService } from "../../../../services/permissions/permissions.service";
import { WarningModalService } from "../../../../services/warning-modal/warning-modal.service";
import { AbstractModalComponent } from "../../../abstract-modal/abstract-modal.component";
import { ConstantsService } from "../../../../services/constants/constants.service";
import { InformationModalComponent } from "../information-modal/information-modal.component";

@Component({
  selector: 'app-list-recipients-modal',
  templateUrl: './list-recipients-modal.component.pug',
  styleUrls: ['./list-recipients-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ListRecipientsModalComponent extends AbstractModalComponent implements OnInit, OnChanges {

  public openModal: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('requestForm', { static: false }) requestForm: any;
  @Input() total = 0;
  @Input() typeOfCheck = ConstantsService.REFERENCE_CHECK;
  @Input() backgroundCheck: any;
  @Input() backgroundChecks: any;
  @Input() flowsSelected : any;
  @Output() updateTotal = new EventEmitter();
  @Output() clearDraftFromList = new EventEmitter();
  @Output() countMobileNos = new EventEmitter();
  @Output() errorCount = new EventEmitter();
  @Output() filters = new EventEmitter();
  @Output() cancelList: EventEmitter<any> = new EventEmitter<any>();
  private bsModalRef: any;
  bulkSendAvailable = true;
  hasBulkUploadPermissions = false;
  bulkUploadTooltipText = ``;
  totalExitRecipientsDetails: any[] = [];
  totalReferenceRecipientsDetails: any[] = [];
  totalBackgroundCheckRecipientsDetails: any[] = [];
  totalPulseRecipientsDetails: any[] = [];
  id = -1;
  pagination = {
    "rowsPerView": 20,
    "currentPage": 1
  }
  sortCriteria = {
    "sortString": 'recipient',
    "sortOrder": 'asc'
  }

  exitSortOptions = [
    {
      'label': "Recipient",
      'type': "word",
      'value': "recipient"
    },
    {
      'label': "Email",
      'type': "word",
      'value': "email"
    },
    {
      'label': "End date",
      'type': "number",
      'value': "end_date"
    },
  ]
  referenceSortOptions = [
    {
      'label': "Recipient",
      'type': "word",
      'value': "recipient"
    },
    {
      'label': "Email",
      'type': "word",
      'value': "email"
    }
  ]
  pulseSortOptions = [
    {
      'label': $localize`Recipient`,
      'type': "word",
      'value': "recipient"
    },
    {
      'label': $localize`Department`,
      'type': "word",
      'value': "department"
    }
  ]
  backgroundCheckSortOptions = [
    {
      'label': "Recipient",
      'type': "word",
      'value': "recipient"
    },
    {
      'label': "Email",
      'type': "word",
      'value': "email"
    }
  ]
  searchTerm = '';
  recipients = {};
  errorRecipients = 0;
  warningRecipients = 0;
  draftResponse = {};
  recipientsWithoutMobile = 0;
  draftUid: string | null = '';
  draftReferenceUid: string | null = '';
  draftBackgroundCheckUid: string | null = '';
  draftPulseUid: string | null = '';
  filterBy = {
    'error': false,
    'warning': false
  };
  phoneUtil = PhoneNumberUtil.getInstance();
  warningModal: BsModalRef = new BsModalRef<any>();
  ENT_8918_MULTIPLE_BC = false;
  TRUST_752_VERIFICATION = false;

  constructor(private modalService: BsModalService,
    private requestService: RequestService,
    private alertList: AlertBannerService,
    private permissions: PermissionsService,
    public _bsModalRef: BsModalRef,
    public modal: WarningModalService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.ENT_8918_MULTIPLE_BC = this.permissions.isFeatureActivated('ent_8918_multiple_bg_checks');
    this.TRUST_752_VERIFICATION = this.permissions.isFeatureActivated('trust-752-certn-checks');
    this.sortStringComp()

    this.hasBulkUploadPermissions = this.permissions.isOrgFeatureEnabled('csv_upload');
    if(!this.hasBulkUploadPermissions){
      this.bulkUploadTooltipText = $localize`Upgrade to enable this feature. Click to request access.`
    }

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.retrieveRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
      this.retrieveReferenceRecipientTableData()
    } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
      this.retrievePulseRecipientTableData()
    } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
      //TODO: Retrieve recipient list when APIs are implemented
    }
  }


  getForm() {
    return this.requestForm;
  }

  getMetaData() {
    this.requestService.metaExit(localStorage.getItem('draft_uid')).subscribe((data: any) => {
      this.updateErrorCountAndEmit(data['error_count'], data['warning_count']);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  getReferenceMetaData() {
    this.requestService.metaBackgroundCheck(localStorage.getItem('draft_reference_uid'), false).subscribe((data: any) => {
        this.updateErrorCountAndEmit(data['error_count'], data['warning_count']);
      },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  deprecatedGetReferenceMetaData(){
    this.requestService.deprecatedMetaReference(localStorage.getItem('draft_reference_uid')).subscribe((data: any) => {
      this.updateErrorCountAndEmit(data['error_count'], data['warning_count']);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }
  getBackgroundCheckMetaData() {
    // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
    this.requestService.metaBackgroundCheck(localStorage.getItem('draft_background_check_uid')).subscribe((data: any) => {
      this.updateErrorCountAndEmit(data['error_count'], data['warning_count']);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  getPulseMetaData() {
    this.requestService.metaPulse(localStorage.getItem('draft_pulse_uid')).subscribe((data: any) => {
      this.updateErrorCountAndEmit(data['error_count'], data['warning_count']);
    },
      (err: any) => {
        console.log(err);
        this.alertList.append([{
          type: AlertType.DANGER,
          message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
          keepOnRouteChange: true
        }]);
      })
  }

  setValues(totalRecipientsDetails) {
    let END_DATE_MONTHS = moment.months();
    this.recipientsWithoutMobile = 0;
    totalRecipientsDetails.forEach(val => {
      if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
        val['end_date_month'] = !val['end_date_month'] || !END_DATE_MONTHS[val['end_date_month'] - 1] ? '' : END_DATE_MONTHS[val['end_date_month'] - 1];
      }
      if (val['mobile_phone'] && val['country_code']) {
        val['valid_mobile'] = true;
        if (!val['country_code'].startsWith('+')) {
          val['country_code'] = '+' + val['country_code'];
        }
        let phone = val['country_code'] + val['mobile_phone'];
        try {
          const parsedPhone = this.phoneUtil.parseAndKeepRawInput(phone);
          val['mobile'] = this.phoneUtil.format(parsedPhone, PhoneNumberFormat.INTERNATIONAL);
        } catch (error) {
          console.log("Phone number parsing error: ", error)
          if (val['mobile_phone'].length > 0) val['mobile'] = val['country_code'] + ' ' + val['mobile_phone'];
        }
      } else {
        val['valid_mobile'] = false;
        this.recipientsWithoutMobile += 1;
      }
      if (val['meta']['error_fields'].length > 0 || val['meta']['warning_fields'].length > 0) {
        val['meta']['isInitialsSet'] = true;
      }
    });
    this.countMobileNos.emit(this.recipientsWithoutMobile);
  }

  filter(event, type) {
    this.filterBy[type] = event.currentTarget.checked;
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) this.retrieveRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) this.retrieveReferenceRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) this.retrievePulseRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) this.retrieveBackgroundCheckRecipientTableData();
    this.filters.emit(this.filterBy)
  }

  showInformationModal() {
    this.bsModalRef = this.modalService.show(InformationModalComponent, {
      class: 'modal-dialog-centered modal-dimensions1',
      initialState: {
        "checkType": this.typeOfCheck,
      }
    });
  }

  onPageChange(pageNumber) {
    this.pagination['currentPage'] = pageNumber;
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) this.retrieveRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) this.retrieveReferenceRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) this.retrievePulseRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) this.retrieveBackgroundCheckRecipientTableData();
  }

  onPageSizeChange(rowsPerView) {
    this.pagination['rowsPerView'] = rowsPerView;
    this.pagination['currentPage'] = 1;
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) this.retrieveRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) this.retrieveReferenceRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) this.retrievePulseRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) this.retrieveBackgroundCheckRecipientTableData();
  }

  onSortChange(sortString: string): void {
    if (sortString.includes('-')) {
      this.sortCriteria['sortOrder'] = 'desc';
      this.sortCriteria['sortString'] = sortString.substring(1);
    } else {
      this.sortCriteria['sortOrder'] = 'asc';
      this.sortCriteria['sortString'] = sortString;
    }
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) this.retrieveRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) this.retrieveReferenceRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) this.retrievePulseRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) this.retrieveBackgroundCheckRecipientTableData();
  }

  configureSortChange(sortString: { key: '', label: '', sortString: '' }): void {
      if (sortString.key.includes('End date')) {
        if (sortString.sortString.includes('-')) {
          this.sortCriteria['sortOrder'] = 'desc';
          this.sortCriteria['sortString'] = "end_date"
        } else {
          this.sortCriteria['sortOrder'] = 'asc';
          this.sortCriteria['sortString'] = "end_date"
        }
      } else {

        if (sortString.sortString.includes('-')) {
          this.sortCriteria['sortOrder'] = 'desc';
          this.sortCriteria['sortString'] = sortString.key.toLowerCase();
        } else {
          this.sortCriteria['sortOrder'] = 'asc';
          this.sortCriteria['sortString'] = sortString.key.toLowerCase();
        }
      }
      if (this.typeOfCheck === ConstantsService.EXIT_CHECK) this.retrieveRecipientTableData();
      else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) this.retrieveReferenceRecipientTableData();
      else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) this.retrievePulseRecipientTableData();
      else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) this.retrieveBackgroundCheckRecipientTableData();

  }

  sortStringComp() {
      if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
        this.sortCriteria['sortOptions'] = ConstantsService.sortCriteriaExitCheck.sortOptions;
        if (localStorage.getItem('draft_uid')) {
          this.draftUid = localStorage.getItem('draft_uid');
          this.retrieveRecipientTableData();
        }
      } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
        this.sortCriteria['sortOptions'] = ConstantsService.sortCriteriaReferenceCheck.sortOptions;
        if (localStorage.getItem('draft_reference_uid')) {
          this.draftReferenceUid = localStorage.getItem('draft_reference_uid');
          this.retrieveReferenceRecipientTableData();
        }
      } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
        this.sortCriteria['sortOptions'] = ConstantsService.sortCriteriaPulseCheck.sortOptions;
        if (localStorage.getItem('draft_pulse_uid')) {
          this.draftPulseUid = localStorage.getItem('draft_pulse_uid');
          this.retrievePulseRecipientTableData();
        }
      } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
        this.sortCriteria['sortOptions'] = ConstantsService.sortCriteriaBackGroundCheck.sortOptions;
        if (localStorage.getItem('draft_background_check_uid')) {
          this.draftBackgroundCheckUid = localStorage.getItem('draft_background_check_uid');
          this.retrieveBackgroundCheckRecipientTableData();
        }
    }
  }

  onSearchChange(searchOptions) {
    if (searchOptions !== undefined) {
      this.searchTerm = searchOptions.value;
    } else {
      this.searchTerm = '';
    }
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) this.retrieveRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) this.retrieveReferenceRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) this.retrievePulseRecipientTableData();
    else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) this.retrieveBackgroundCheckRecipientTableData();
  }

  clear() {
    this._bsModalRef.hide();
    let title = '';
    if (this.total === 1) title = $localize`Remove recipient`
    else title = $localize`Remove recipients`
    let initialState = {
      "title": title,
      "message": $localize`Do you want to continue?`
    };
    this.warningModal = this.modalService.show(WarningModalContentComponent, {
      class: 'modal-dialog-centered', initialState
    });
    this.warningModal.content.selection.subscribe(res => {
      if (res === true) {
        this.warningModal.hide();
        this.clearDraftFromList.emit();
      }
    })
  }

  deleteRecipient(data) {
    this.draftUid = data['draft_uid'];
    if (data['error_count'] === 0) if (this.filterBy.error) this.filterBy.error = false;
    if (data['warning_count'] === 0) if (this.filterBy.warning) this.filterBy.warning = false;
    this.retrieveRecipientTableData();
    this.total = data['total_exits'];
    let dataToEmit = {
      'total': this.total
    }
    this.updateTotal.emit(dataToEmit);
  }

  deleteReferenceRecipient(data) {
    this.draftUid = data['draft_check_uid'];
    if (data['error_count'] === 0) if (this.filterBy.error) this.filterBy.error = false;
    if (data['warning_count'] === 0) if (this.filterBy.warning) this.filterBy.warning = false;
    this.retrieveReferenceRecipientTableData();
    this.total =  data['total_external_checks'];
    let dataToEmit = {
      'total': this.total
    }
    this.updateTotal.emit(dataToEmit);
  }

  deleteBackgroundCheckRecipient(data) {
    this.draftUid = data['draft_reference_uid'];
    if (data['error_count'] === 0) if (this.filterBy.error) this.filterBy.error = false;
    if (data['warning_count'] === 0) if (this.filterBy.warning) this.filterBy.warning = false;
    this.retrieveReferenceRecipientTableData();
    this.total = data['total_external_checks'];
    let dataToEmit = {
      'total': this.total
    }
    this.updateTotal.emit(dataToEmit);
  }

  deletePulseRecipient(data) {
    this.draftUid = data['draft_pulse_uid'];
    if (data['error_count'] === 0) if (this.filterBy.error) this.filterBy.error = false;
    if (data['warning_count'] === 0) if (this.filterBy.warning) this.filterBy.warning = false;
    this.retrievePulseRecipientTableData();
    this.total = data['total_pulses'];
    let dataToEmit = {
      'total': this.total
    }
    this.updateTotal.emit(dataToEmit);
  }

  editRecipient(data) {
    if (data['error_count'] === 0) if (this.filterBy.error) this.filterBy.error = false;
    if (data['warning_count'] === 0) if (this.filterBy.warning) this.filterBy.warning = false;
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.draftUid = data['draft_uid'];
      this.retrieveRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
        this.draftReferenceUid = data['draft_check_uid'];
        this.retrieveReferenceRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
      this.draftReferenceUid = data['draft_pulse_uid'];
      this.retrievePulseRecipientTableData();
    } else if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
      // TODO: need to modify draft_reference_uid with draft_background_check_uid after backend implementation
      this.draftBackgroundCheckUid =  data['draft_reference_uid']
      this.retrieveBackgroundCheckRecipientTableData()
    }
  }

  retrieveRecipientTableData() {
    this.requestService.retrieveDraftExit(localStorage.getItem('draft_uid'), this.searchTerm, this.pagination['rowsPerView'], this.pagination['currentPage'], this.sortCriteria['sortString'], this.sortCriteria['sortOrder'], this.filterBy).subscribe((data: any) => {
      this.totalExitRecipientsDetails = data['exits'];
      this.total = data['total_exits'];
      this.setValues(this.totalExitRecipientsDetails);
      if (this.total === 0) {
        this.updateErrorCountAndEmit(0, 0);
      } else {
        this.getMetaData();
      }
    },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )
  }

  retrieveReferenceRecipientTableData() {
    this.requestService.retrieveDraftBackgroundCheck(localStorage.getItem('draft_reference_uid'), this.searchTerm, this.pagination['rowsPerView'], this.pagination['currentPage'], this.sortCriteria['sortString'], this.sortCriteria['sortOrder'], this.filterBy, undefined, false).subscribe((data: any) => {
        this.totalReferenceRecipientsDetails = data['external_checks'];
        this.total = data['total_external_checks'];
        this.setValues(this.totalReferenceRecipientsDetails);
        if (this.total === 0) {
          this.updateErrorCountAndEmit(0, 0);
        } else {
          this.getReferenceMetaData();
        }
      },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_reference_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )
  }

  retrieveBackgroundCheckRecipientTableData() {
    let checks: any;
    if(this.ENT_8918_MULTIPLE_BC)
      checks = this.backgroundChecks
    else
      checks = this.backgroundCheck

    // TODO: need to update draft_reference_uid with the background check draft id, after backend implementation
    this.requestService.retrieveDraftBackgroundCheck(
      localStorage.getItem('draft_background_check_uid'),
      this.searchTerm, this.pagination['rowsPerView'],
      this.pagination['currentPage'], this.sortCriteria['sortString'],
      this.sortCriteria['sortOrder'], this.filterBy, checks
    ).subscribe((data: any) => {
      this.totalBackgroundCheckRecipientsDetails = data['external_checks'];
      this.total = data['total_external_checks'];
      this.setValues(this.totalBackgroundCheckRecipientsDetails);
      if (this.total === 0) {
        this.updateErrorCountAndEmit(0, 0);
      } else {
        this.getBackgroundCheckMetaData();
      }
    },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_background_check_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )
  }

  retrievePulseRecipientTableData() {
    this.requestService.retrieveDraftPulse(localStorage.getItem('draft_pulse_uid'), this.searchTerm, this.pagination['rowsPerView'], this.pagination['currentPage'], this.sortCriteria['sortString'], this.sortCriteria['sortOrder'], this.filterBy).subscribe((data: any) => {
      this.totalPulseRecipientsDetails = data['pulses'];
      this.total = data['total_pulses'];
      this.setValues(this.totalPulseRecipientsDetails);
      if (this.total === 0) {
        this.updateErrorCountAndEmit(0, 0);
      } else {
        this.getPulseMetaData();
      }
    },
      (err: any) => {
        if (err.status === 404) {
          localStorage.removeItem('draft_pulse_uid')
        } else {
          console.log(err);
          this.alertList.append([{
            type: AlertType.DANGER,
            message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
            keepOnRouteChange: true
          }]);
        }
      }
    )
  }

  onClear() {
    if (this.typeOfCheck === ConstantsService.EXIT_CHECK) {
      this.totalExitRecipientsDetails = [];
    }
    if (this.typeOfCheck === ConstantsService.REFERENCE_CHECK) {
      this.totalReferenceRecipientsDetails = [];
    }
    if (this.typeOfCheck === ConstantsService.PULSE_CHECK) {
      this.totalPulseRecipientsDetails = [];
    }
    if (this.typeOfCheck === ConstantsService.BACKGROUND_CHECK) {
      this.totalBackgroundCheckRecipientsDetails = [];
    }
    this.updateErrorCountAndEmit(0, 0);
  }

  updateErrorCountAndEmit(errorRecipients, warningRecipients) {
    this.errorRecipients = errorRecipients;
    this.warningRecipients = warningRecipients;
    let payload = {
      "error": this.errorRecipients,
      "warning": this.warningRecipients
    }
    this.errorCount.emit(payload);
  }

  cancel() {
    this.cancelList.emit(Math.floor(Math.random() * 100));
    this._bsModalRef.hide();
  }

  openBulkRequest() {
    this.openModal.emit('open-bulk-request');
    this._bsModalRef.hide();
  }

  openAddRecipient() {
    this.openModal.emit('open-add-recipient');
    this._bsModalRef.hide();
  }

}
